/* Query dimensions (question type, conversation type, intent, user need, journey stage)
   and topic inference. Extracted verbatim from artifact.html <script id="logic">. */

export function inferDimensions(q, bucket) {
  const s = q.toLowerCase();
  let qt;
  if (/\bcompare\b|\bvs\b|\bversus\b|difference between/.test(s)) qt = "compare";
  else if (/^(best|top) |\bbest\b/.test(s)) qt = "best";
  else if (/^how|kaise|कैसे/.test(s)) qt = "how";
  else if (/^why|kyon|क्यों/.test(s)) qt = "why";
  else if (/^which|kaun sa|कौन सा|kaun si/.test(s)) qt = "which";
  else if (/^can /.test(s)) qt = "can";
  else if (/^could /.test(s)) qt = "could";
  else if (/^(should|shall) /.test(s)) qt = "should";
  else if (/^where|kahan|कहाँ/.test(s)) qt = "where";
  else if (/^when|kab\b|कब/.test(s)) qt = "when";
  else if (/^who\b/.test(s)) qt = "who";
  else if (/^(is|are) /.test(s)) qt = "is_are";
  else if (/^(do|does|did) /.test(s)) qt = "do_does";
  else if (/^what|kya |क्या|kis (roop|kam)|किस/.test(s) || /kya (kar|khana|labh)/.test(s)) qt = "what";
  else if (/kitne|कितने/.test(s)) qt = "when";
  else qt = "none";

  let ct = null;
  if (bucket === "artefact") ct = /^(yes|ok|sure|sounds good|got it|yes that one)/.test(s) ? "confirmation" : (/more/.test(s) ? "request_for_more" : "continuation");
  else if (bucket === "pivot") ct = "refinement";
  else if (bucket === "conversational" || bucket === "uncertain") {
    if (/\b(recommend|suggest)\b/.test(s)) ct = "recommendation";
    else if (/\b(vs|versus|difference|compare|antar|अंतर)\b/.test(s) || /(use|mix) .* and .* together/.test(s)) ct = "comparison";
    else if (/^(write|give|make|create|order|book|plan)( me| us)?\b/.test(s) || /^explain like\b/.test(s)) ct = "action_request";
    else if (/(nothing works|getting worse|tried everything|what went wrong|kitne din|how long|kab tak)/.test(s)) ct = "follow_up";
    else if (/(is it safe|can i (use|take|give)|can we use|meaning|matlab|how to know|do you have)/.test(s)) ct = "clarification";
    else if (/^(i want|i need|show me)/.test(s)) ct = "request_for_more";
    else ct = "initial_question";
  }

  let intent;
  if (/\b(buy|order|purchase|price|pricing|coupon|combo pack|online india|cash on delivery)\b/.test(s) || /where can i (find|get|buy)/.test(s)) intent = "transactional";
  else if (/\b(best|recommend|suggest|top|review|vs|versus|compare|better)\b/.test(s)) intent = "commercial";
  else if (bucket === "navigational") intent = "navigational";
  else intent = "informational";

  let need;
  if (intent === "transactional") need = "buy";
  else if (ct === "recommendation") need = "choose";
  else if (ct === "comparison" || qt === "compare") need = "compare";
  else if (/(fix|treat|cure|reduce|stop|worse|nothing works|problem|dard|ilaj|pain)/.test(s)) need = /(worse|nothing works|tried everything)/.test(s) ? "troubleshoot" : "solve";
  else if (ct === "action_request" && /(plan|routine|checklist|7 day)/.test(s)) need = "plan";
  else if (/(is it safe|can i (use|take|give)|can we use|should i take|how to know if)/.test(s)) need = "validate";
  else if (/^(what is|what are)\b/.test(s) || /(meaning|matlab|explain)/.test(s)) need = "understand";
  else if (bucket === "navigational" || /^where\b/.test(s)) need = "find";
  else if (qt === "best" || intent === "commercial") need = "evaluate";
  else need = "learn";

  const J = {
    understand: "education", learn: "discovery", solve: "problem", troubleshoot: "troubleshooting",
    compare: "comparison", choose: "decision", evaluate: "evaluation", validate: "evaluation",
    buy: "purchase", plan: "research", find: "decision",
  };
  let journey = J[need] || "research";
  if (/(how to use|how to apply|dosage|kaise (use|istemal))/.test(s)) journey = "post_purchase";
  return { qt, ct, intent, need, journey };
}

/* Fixed display order of the 10 journey stages (drives the Journey filter + diagram). */
export const JOURNEY_ORDER = ["discovery", "education", "problem", "research", "evaluation", "comparison", "decision", "purchase", "post_purchase", "troubleshooting"];

/* Journey phases (4) over the 10 stages. */
export const JOURNEY_PHASE = {
  discovery: "awareness", education: "awareness",
  problem: "consideration", research: "consideration", evaluation: "consideration", comparison: "consideration",
  decision: "decision", purchase: "decision",
  post_purchase: "ownership", troubleshooting: "ownership",
};

const STOP = new Set("the a an of for and or is are was were with without best top how what why which where when who can could should would shall i we you my me your it its this that any some more most in on to at by from do does did ho hai hain ke ki ka ko se me mein kya kaise per online india price buy near review reviews vs versus about like into good bad new old day daily use uses using में के की का को से और है हैं पर यह वह क्या कैसे करना करने करें चाहिए लिए kare karen karna karne liye aur par jaye wala wali hota hoti hote".split(" "));

export function tokens(str) {
  return String(str).toLowerCase().replace(/https?:\/\/[^/]+/, "").split(/[^a-z\u0900-\u097F0-9]+/).filter(t => t.length > 2 && !STOP.has(t));
}

/* Assigns topic + subtopic in place, by corpus token frequency. Rows that already carry a
   topic (the demo dataset) are left untouched. */
export function inferTopics(all) {
  const freq = {};
  for (const d of all) for (const t of new Set(tokens(d.q))) freq[t] = (freq[t] || 0) + 1;
  const cap = w => w.charAt(0).toUpperCase() + w.slice(1);
  for (const d of all) {
    if (d.topic) continue;
    const ts = tokens(d.q).slice().sort((a, b) => (freq[b] || 0) - (freq[a] || 0));
    d.topic = ts.length ? cap(ts[0]) : "Other";
    d.sub = ts.length > 1 ? cap(ts[1]) : "";
  }
}
